import { ButtonColor, ButtonVariant, Icon, TextButton, Typography, TypographyType } from '../../../components';
import { TextColor } from '../../../types';

interface TabSectionProps {
  children: React.ReactNode;
  title: string;
  description?: string;
  isRegenerating?: boolean;
  onRegenerate?: () => void;
}

const TabSection = ({ children, description, title, isRegenerating, onRegenerate }: TabSectionProps) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <div className="flex items-center justify-between gap-1">
          <Typography type={TypographyType.H4} className="select-none">
            {title}
          </Typography>
          {onRegenerate && (
            <TextButton
              color={ButtonColor.NEUTRAL}
              variant={ButtonVariant.SOFT}
              startIcon={Icon.FAST_FORWARD}
              loading={isRegenerating}
              onClick={onRegenerate}
              text="Regenerate"
            />
          )}
        </div>
        <Typography type={TypographyType.X_SMALL} color={TextColor.SECONDARY} className="select-none">
          {description}
        </Typography>
      </div>
      {children}
    </div>
  );
};

export default TabSection;
